module.exports = __webpack_public_path__ + "static/img/authenticationSuccess.364a127.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/authenticationSuccess.png
// module id = SmHf
// module chunks = 0